import { createReducer } from 'redux-act';
import actions from "../actions/authActions";

const initialState = {
  isUserLoginPending: false,
  userLoginRes: null,
  userLoginResError: null,

  logoutPending: false,
  logoutRes: null,
  logoutError: null,

  resetPasswordPending: false,
  resetPasswordRes: null,
  resetPasswordError: null,

  forgotPasswordPending: false,
  forgotPasswordRes: null,
  forgotPasswordError: null,

  sendOtpPending: false,
  sendOtpRes: null,
  sendOtpError: null,

  verifyOtpPending: false,
  verifyOtpRes: null,
  verifyOtpError: null,

  forgotPasswordForAdminPending: false,
  forgotPasswordForAdminRes: null,
  forgotPasswordForAdminError: null,

  switchAccountsPending: false,
  switchAccountsRes: null,
  switchAccountsError: null,

  completeClientOnboardStep: false
};
/* Login Reducers */
const handleUserLoginRequest = state => {
  return {
    ...state,
    ...{
      isUserLoginPending: true,
      userLoginRes: null,
      userLoginResError: null,
    },
  };
};
const handleUserLoginSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      isUserLoginPending: false,
      userLoginRes: payload,
      userLoginResError: null,
    },
  };
};
const handleUserLoginError = (state, payload) => ({
  ...state,
  ...{
    isUserLoginPending: false,
    userLoginRes: null,
    userLoginResError: payload,
  },
});


/* logout Reducers */
const handleLogoutRequest = state => {
  return {
    ...state,
    ...{
      logoutPending: true,
      logoutRes: null,
      logoutError: null,
    },
  };
};
const handleLogoutSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      logoutPending: false,
      logoutRes: payload,
      logoutError: null,
    },
  };
};
const handleLogoutError = (state, payload) => ({
  ...state,
  ...{
    logoutPending: false,
    logoutRes: null,
    logoutError: payload,
  },
});

/* Reset Password Reducers */
const handleResetPasswordRequest = state => {
  return {
    ...state,
    ...{
      resetPasswordPending: true,
      resetPasswordRes: null,
      resetPasswordError: null,
    },
  };
};
const handleResetPasswordSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      resetPasswordPending: false,
      resetPasswordRes: payload,
      resetPasswordError: null,
    },
  };
};
const handleResetPasswordError = (state, payload) => ({
  ...state,
  ...{
    resetPasswordPending: false,
    resetPasswordRes: null,
    resetPasswordError: payload,
  },
});

/* Forgot Password Reducers */
const handleForgotPasswordRequest = state => {
  return {
    ...state,
    ...{
      forgotPasswordPending: true,
      forgotPasswordRes: null,
      forgotPasswordError: null,
    },
  };
};
const handleForgotPasswordSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      forgotPasswordPending: false,
      forgotPasswordRes: payload,
      forgotPasswordError: null,
    },
  };
};
const handleForgotPasswordError = (state, payload) => ({
  ...state,
  ...{
    forgotPasswordPending: false,
    forgotPasswordRes: null,
    forgotPasswordError: payload,
  },
});


/* Send Otp Reducers */
const handleSendOtpRequest = state => {
  return {
    ...state,
    ...{
      sendOtpPending: true,
      sendOtpRes: null,
      sendOtpError: null,
    },
  };
};
const handleSendOtpSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      sendOtpPending: false,
      sendOtpRes: payload,
      sendOtpError: null,
    },
  };
};
const handleSendOtpError = (state, payload) => ({
  ...state,
  ...{
    sendOtpPending: false,
    sendOtpRes: null,
    sendOtpError: payload,
  },
});

/* Verify Otp Reducers */
const handleVerifyOtpRequest = state => {
  return {
    ...state,
    ...{
      verifyOtpPending: true,
      verifyOtpRes: null,
      verifyOtpError: null,
    },
  };
};
const handleVerifyOtpSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      verifyOtpPending: false,
      verifyOtpRes: payload,
      verifyOtpError: null,
    },
  };
};
const handleVerifyOtpError = (state, payload) => ({
  ...state,
  ...{
    verifyOtpPending: false,
    verifyOtpRes: null,
    verifyOtpError: payload,
  },
});


/* forgot Password For Admin Reducers */
const handleForgotPasswordForAdminRequest = state => {
  return {
    ...state,
    ...{
      forgotPasswordForAdminPending: true,
      forgotPasswordForAdminRes: null,
      forgotPasswordForAdminError: null,
    },
  };
};
const handleForgotPasswordForAdminSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      forgotPasswordForAdminPending: false,
      forgotPasswordForAdminRes: payload,
      forgotPasswordForAdminError: null,
    },
  };
};
const handleForgotPasswordForAdminError = (state, payload) => ({
  ...state,
  ...{
    forgotPasswordForAdminPending: false,
    forgotPasswordForAdminRes: null,
    forgotPasswordForAdminError: payload,
  },
});

/* forgot Password For Admin Reducers */
const handleSwitchAccountsRequest = state => {
  return {
    ...state,
    ...{
      switchAccountsPending: true,
      switchAccountsRes: null,
      switchAccountsError: null,
    },
  };
};
const handleSwitchAccountsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      switchAccountsPending: false,
      switchAccountsRes: payload,
      switchAccountsError: null,
    },
  };
};
const handleSwitchAccountsError = (state, payload) => ({
  ...state,
  ...{
    switchAccountsPending: false,
    switchAccountsRes: null,
    switchAccountsError: payload,
  },
});

const handleCompleteClientOnboardingStep = (state1, payload) => ({
  ...state1,
  ...{
    completeClientOnboardStep: payload,
  }
});




/* Handle Clear Auth Store */
const handleClearAuthStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_LOGIN_STORE':
      return {
        ...state,
        ...{
          isUserLoginPending: false,
          userLoginRes: null,
          userLoginResError: null,
        },
      };

    case 'HANDLE_CLEAR_LOGOUT_STORE':
      return {
        ...state,
        ...{
          logoutPending: false,
          logoutRes: null,
          logoutError: null,
        },
      };
    case 'HANDLE_CLEAR_RESET_PASSWORD_STORE':
      return {
        ...state,
        ...{
          resetPasswordPending: false,
          resetPasswordRes: null,
          resetPasswordError: null,
        },
      };

    case 'HANDLE_CLEAR_FORGOT_PASSWORD_STORE':
      return {
        ...state,
        ...{
          forgotPasswordPending: false,
          forgotPasswordRes: null,
          forgotPasswordError: null,
        },
      };
    case 'HANDLE_CLEAR_SEND_OTP_STORE':
      return {
        ...state,
        ...{
          sendOtpPending: false,
          sendOtpRes: null,
          sendOtpError: null,
        },
      };

    case 'HANDLE_CLEAR_VERIFY_OTP_STORE':
      return {
        ...state,
        ...{
          verifyOtpPending: false,
          verifyOtpRes: null,
          verifyOtpError: null,
        },
      };

    case 'HANDLE_CLEAR_FORGOT_PASSWORD_FOR_ADMIN_STORE':
      return {
        ...state,
        ...{
          forgotPasswordForAdminPending: false,
          forgotPasswordForAdminRes: null,
          forgotPasswordForAdminError: null,
        },
      };
    case 'HANDLE_CLEAR_SWITCH_ACCOUNTS_STORE':
      return {
        ...state,
        ...{
          switchAccountsPending: false,
          switchAccountsRes: null,
          switchAccountsError: null,
        },
      };
    default:
      return state;
  }
};

export default createReducer(
  {
    [actions.userLoginRequest]: handleUserLoginRequest,
    [actions.userLoginSuccess]: handleUserLoginSuccess,
    [actions.userLoginError]: handleUserLoginError,

    [actions.logoutRequest]: handleLogoutRequest,
    [actions.logoutSuccess]: handleLogoutSuccess,
    [actions.logoutError]: handleLogoutError,

    [actions.resetPasswordRequest]: handleResetPasswordRequest,
    [actions.resetPasswordSuccess]: handleResetPasswordSuccess,
    [actions.resetPasswordError]: handleResetPasswordError,

    [actions.forgotPasswordRequest]: handleForgotPasswordRequest,
    [actions.forgotPasswordSuccess]: handleForgotPasswordSuccess,
    [actions.forgotPasswordError]: handleForgotPasswordError,

    [actions.sendOtpRequest]: handleSendOtpRequest,
    [actions.sendOtpSuccess]: handleSendOtpSuccess,
    [actions.sendOtpError]: handleSendOtpError,

    [actions.verifyOtpRequest]: handleVerifyOtpRequest,
    [actions.verifyOtpSuccess]: handleVerifyOtpSuccess,
    [actions.verifyOtpError]: handleVerifyOtpError,

    [actions.forgotPasswordForAdminRequest]: handleForgotPasswordForAdminRequest,
    [actions.forgotPasswordForAdminSuccess]: handleForgotPasswordForAdminSuccess,
    [actions.forgotPasswordForAdminError]: handleForgotPasswordForAdminError,

    [actions.switchAccountsRequest]: handleSwitchAccountsRequest,
    [actions.switchAccountsSuccess]: handleSwitchAccountsSuccess,
    [actions.switchAccountsError]: handleSwitchAccountsError,

    [actions.completeClientOnboardStep]: handleCompleteClientOnboardingStep,

    // Clear Auth Store
    [actions.handleClearAuthStore]: handleClearAuthStore,
  },
  initialState,
);